// extracted by mini-css-extract-plugin
export default {"sectionProduct":"SectionProducts_sectionProduct__k02d1"};